import { Box, Modal, Text } from "@modernatx/ui-kit-react-v2";
import React from "react";

interface DropdownFooterProps {
  productsEligibilityMessage: string;
}

export const RsvFooterNote: React.FC<DropdownFooterProps> = ({ productsEligibilityMessage }) => {
  const [showLearnMore, setShowLearnMore] = React.useState(false);

  return (
    <Box sx={{ padding: "spacing-5" }}>
      <Box sx={{ position: "absolute", left: 5 }}>*</Box>
      <Text variant="body-1-regular" lineHeight="leading-2">
        {productsEligibilityMessage}{" "}
        <Box
          as="button"
          aria-haspopup="dialog"
          aria-label="Learn more about severe underlying medical conditions"
          sx={{
            display: "inline",
            textDecoration: "underline",
            cursor: "pointer",
            ":hover": { color: "color-system-gray-500" }
          }}
          onClick={() => setShowLearnMore(true)}
        >
          Learn more
        </Box>
      </Text>
      <Modal isOpen={showLearnMore} size="xs" onDismiss={() => setShowLearnMore(false)}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Text
            variant="h4-light"
            sx={{
              color: () => "#0E6896",
              lineHeight: "leading-2"
            }}
          >
            About severe underlying medical conditions
          </Text>
          <Text as="p" variant="body-1-regular">
            The RSV vaccine is not recommended for adults under 60 without severe underlying health
            conditions.
          </Text>
          <Text as="p" variant="body-1-regular">
            For more information, please consult your healthcare provider or visit the official
            Moderna website.
          </Text>
          <Text as="p" variant="body-1-regular">
            Generated Text.
          </Text>
        </Box>
      </Modal>
    </Box>
  );
};
